// t = type, d = default type aka is it shown in the 
// initial list before the show more button is clicked?
// if true, then it is shown in the default list

module.exports.gender = [
  {t: "Agender", d: false, },
  {t: "Female", d: true, },
  {t: "Gender Fluid", d: false, },
  {t: "Gender Nonconforming", d: false, },
  {t: "Gender Questioning", d: false, },
  {t: "Genderqueer", d: false, },
  {t: "Intersex", d: false, },
  {t: "Male", d: true, },
  {t: "Non-binary", d: true, },
  {t: "Other", d: true, },
  {t: "Prefer not to say", d: true, },
  {t: "Trans Female", d: false, },
  {t: "Trans Male", d: false, },
  {t: "Trans Person", d: false, },
];

module.exports.lookingForOther = [
  {t: "Agender", d: false, },
  {t: "Gender Fluid", d: false, },
  {t: "Gender Nonconforming", d: false, },
  {t: "Gender Questioning", d: false, },
  {t: "Genderqueer", d: false, },
  {t: "Intersex", d: false, },
  {t: "Men", d: true, },
  {t: "Non-binary", d: true, },
  {t: "Women", d: true, },
  {t: "Trans Female", d: false, },
  {t: "Trans Male", d: false, },
  {t: "Trans Person", d: false, },
];

// let genders = [
//   {t: "Agender", d: false, },
//   {t: "Androgyne", d: false, },
//   {t: "Androgynous", d: false, },
//   {t: "Bigender", d: false, },
//   {t: "Cis", d: false, },
//   {t: "Cisgender", d: false, },
//   {t: "Cis Female", d: false, },
//   {t: "Cis Male", d: false, },
//   {t: "Cis Man", d: false, },
//   {t: "Cis Woman", d: false, },
//   {t: "Cisgender Female", d: false, },
//   {t: "Cisgender Male", d: false, },
//   {t: "Cisgender Man", d: false, },
//   {t: "Cisgender Woman", d: false, },
//   {t: "Female", d: true, },
//   {t: "Female to Male", d: false, },
//   {t: "FTM", d: false, },
//   {t: "Gender Fluid", d: false, },
//   {t: "Gender Nonconforming", d: false, },
//   {t: "Gender Questioning", d: false, },
//   {t: "Gender Variant", d: false, },
//   {t: "Genderqueer", d: false, },
//   {t: "Intersex", d: false, },
//   {t: "Male", d: true, },
//   {t: "Male to Female", d: false, },
//   {t: "MTF", d: false, },
//   {t: "Neither", d: false, },
//   {t: "Neutrois", d: false, },
//   {t: "Non-binary", d: true, },
//   {t: "Other", d: true, },
//   {t: "Pangender", d: false, },
//   {t: "Prefer not to say", d: true, },
//   {t: "Trans", d: false, },
//   {t: "Trans*", d: false, },
//   {t: "Trans Female", d: false, },
//   {t: "Trans* Female", d: false, },
//   {t: "Trans Male", d: false, },
//   {t: "Trans* Male", d: false, },
//   {t: "Trans Man", d: false, },
//   {t: "Trans* Man", d: false, },
//   {t: "Trans Person", d: false, },
//   {t: "Trans* Person", d: false, },
//   {t: "Trans Woman", d: false, },
//   {t: "Trans* Woman", d: false, },
//   {t: "Transfeminine", d: false, },
//   {t: "Transgender", d: false, },
//   {t: "Transgender Female", d: false, },
//   {t: "Transgender Male", d: false, },
//   {t: "Transgender Man", d: false, },
//   {t: "Transgender Person", d: false, },
//   {t: "Transgender Woman", d: false, },
//   {t: "Transmasculine", d: false, },
//   {t: "Transsexual", d: false, },
//   {t: "Transsexual Female", d: false, },
//   {t: "Transsexual Male", d: false, },
//   {t: "Transsexual Man", d: false, },
//   {t: "Transsexual Person", d: false, },
//   {t: "Transsexual Woman", d: false, },
//   {t: "Two-Spirit", d: false, },
// ];
